import lang from './../../../../languages/en'
import { regexAllCharacter, regexContainSpaces, 
    atLeastOneUperCase, atLeastOneLowerCase, 
    atLeastOneNumber 
} from './../../../../services/ruleValidate';

export const checkValidatePassword = (password, confirmPassword) => {
    let message = {}

    // merge password and confirm password
    if (password.trim() !== confirmPassword.trim()) {
        message = {
            name: 'error',
            value: lang.password_not_match
        }
    }

    // least one uppercase
    if (!atLeastOneUperCase(confirmPassword)) {
        message = {
            name: 'confirmPassword',
            value: lang.least_on_uppercase_letter
        }
    }
    if (!atLeastOneUperCase(password)) {
        message = {
            name: 'password',
            value: lang.least_on_uppercase_letter
        }
    }

    // least on lower case
    if (!atLeastOneLowerCase(confirmPassword)) {
        message = {
            name: 'confirmPassword',
            value: lang.least_one_lowercase_letter
        }
    }
    if (!atLeastOneLowerCase(password)) {
        message = {
            name: 'password',
            value: lang.least_one_lowercase_letter
        }
    }

    // check lease on number
    if (!atLeastOneNumber(confirmPassword)) {
        message = {
            name: 'confirmPassword',
            value: lang.least_on_number
        }
    }
    if (!atLeastOneNumber(password)) {
        message = {
            name: 'password',
            value: lang.least_on_number
        }
    }

    // check character
    if (!regexAllCharacter(confirmPassword)) {
        message = {
            name: 'confirmPassword',
            value: lang.cannot_contain_double_byte
        }
    }
    if (!regexAllCharacter(password)) {
        message = {
            name: 'password',
            value: lang.cannot_contain_double_byte
        }
    }

    // check contain spaces
    if (!regexContainSpaces(confirmPassword)) {
        message = {
            name: 'confirmPassword',
            value: lang.cannot_contain_spaces
        }
    }
    if (!regexContainSpaces(password)) {
        message = {
            name: 'password',
            value: lang.cannot_contain_spaces
        }
    }

    // least eight character
    if (confirmPassword.length < 8) {
        message = {
            name: 'confirmPassword',
            value: lang.least_eight_character
        }
    }
    if (password.length < 8) {
        message = {
            name: 'password',
            value: lang.least_eight_character
        }
    }

    return message
}

export const checkInputEmpty = (value, name) => {
    let message = {}
    if (name === 'password' && !value) {
        message = {
            name: name,
            value: lang.new_password
        }
    }
    if (name === 'confirmPassword' && !value) {
        message = {
            name: name,
            value: lang.confirm_new_password
        }
    }

    return message
}


// WEBPACK FOOTER //
// ./src/containers/auth/forgot-password/reset-password/helper.js